import { render, staticRenderFns } from "./menu-select-field.vue?vue&type=template&id=463a705e&scoped=true&"
import script from "./menu-select-field.vue?vue&type=script&lang=js&"
export * from "./menu-select-field.vue?vue&type=script&lang=js&"
import style0 from "./menu-select-field.vue?vue&type=style&index=0&id=463a705e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463a705e",
  null
  
)

export default component.exports